export default __webpack_public_path__ + "static/syselvenoffice-0b047b474f8e9f4844c08b8078217024.jpg";